import { Rule } from 'antd/es/form'
import { useTranslation } from 'react-i18next'

const useBlocktrainRules = () => {
  const { t } = useTranslation()

  const blocktrainRules: { [key: string]: Rule[] } = {
    rayCarWayBill: [
      {
        required: false,
      },
      {
        min: 3,
        message: t('min_3_characters'),
      },
      {
        max: 30,
        message: t('max_30_characters'),
      },
    ],
    deliveryNote: [
      {
        required: true,
      },
      {
        min: 3,
        message: t('min_3_characters'),
      },
      {
        max: 30,
        message: t('max_30_characters'),
      },
    ],
  }

  return blocktrainRules
}

export { useBlocktrainRules }
